/**
 * Says a page needs the garden's postcode, and links to Today, where it is
 * asked for (the other tabs are hidden until it is given, so this shows only
 * on a page opened by its address).
 *
 * Used by: features/plant-list PlantGrid.
 *
 * @module ZipRequiredBanner
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '@/shared/hooks/useTranslation';

/**
 * Warning callout (the theme's warning colours) for a page that cannot work
 * without the postcode.
 * @returns {JSX.Element} Banner with a link to Today.
 */
export const ZipRequiredBanner: React.FC = () => {
  const { reactTranslate: t } = useTranslation();

  return (
    <div className="mb-6 rounded-lg border border-warning/40 bg-warning-tint px-4 py-3 text-warning">
      <p className="text-sm">{t('plants.zipRequired')}</p>
      <Link
        to="/today"
        className="mt-2 inline-block text-sm font-medium underline underline-offset-2"
      >
        {t('plants.goToToday')}
      </Link>
    </div>
  );
};
